import { objectOfType } from 'app/infrastructure/data/object';
import { ComplexValue } from 'app/types-shared';

export const mapCategories = (codes: ComplexValue<number | string>[], wireCodes: any = []) => codes.map(
  (code, index) => ({ ...code, category: wireCodes[index]?.category })
);

export const mapDescendantCount = (codes: ComplexValue<number | string>[], wireCodes: any = []) => codes.map(
  (code, index) => ({
    ...code, ...(wireCodes[index]?.descendantCount > 0 && {
      descendants: [objectOfType<ComplexValue<number | string>>()]
    })
  })
);
